// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.transaction-item-container-gu6uq {
  width: 100%;
  display: flex;
  align-items: center;
  position: relative;
  background-color: white;
  padding: 16px 12px;
}

.transaction-item-container-gu6uq * {
  cursor: default;
}

.transaction-item-background-Lan9C {
  position: absolute;
  top: 0px;
  right: 0px;
  bottom: 0px;
  left: 0px;
  border-radius: var(--large-border-radius);
}

.transaction-item-container-gu6uq:hover .transaction-item-background-Lan9C {
  background-color: var(--color-neutral-100);
}

.transaction-item-container-gu6uq:active .transaction-item-background-Lan9C {
  background-color: var(--color-neutral-200);
}

.transaction-item-image-qeQyC {
  width: 44px;
  height: 44px;
  margin-right: 24px;
  z-index: 1;
}

.transaction-item-info-ER8JG {
  height: 48px;
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  z-index: 1;
}

.transaction-item-row-gQ13Y {
  display: flex;
  align-items: center;
}

.transaction-item-topRow-JGQW0 {
  justify-content: space-between;
  align-items: center;
}

.transaction-item-bottomRow-wUTpd {
}

.transaction-item-phone-vcMmM {
  font-size: 16px;
}

.transaction-item-amount-lKX30 {
  font-weight: 500;
  color: var(--money-color);
}

.transaction-item-iconSpace-BRP5m {
  width: 20px;
  height: 20px;
}

.transaction-item-icon-vD3Y_ {
  --size: 20px;
  width: 44px;
  height: 44px;
  position: absolute;
  top: 4px;
  right: 0px;
  cursor: pointer;
  z-index: 1;
  padding: 12px;
  border-radius: 50%;
}

.transaction-item-icon-vD3Y_:active {
  background-color: var(--active-color);
}

.transaction-item-type-eLLdg, .transaction-item-time-xDFwn {
  color: #707070;
}

.transaction-item-type-eLLdg {
  margin-right: 12px;
}

.transaction-item-cancelled-LmPFf {
  font-size: 12px;
  font-weight: 500;
  color: var(--accent-color);
  background-color: #F1262611;
  margin-left: auto;
  padding: 2px 6px;
  border-radius: 2px;
}
`, "",{"version":3,"sources":["webpack://./../core/src/components/transaction-item/transaction-item.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,WAAW;EACX,SAAS;EACT,yCAAyC;AAC3C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EAEE,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;AAEA;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,eAAe;EACf,UAAU;EACV,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,2BAA2B;EAC3B,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB","sourcesContent":[".container {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  position: relative;\n  background-color: white;\n  padding: 16px 12px;\n}\n\n.container * {\n  cursor: default;\n}\n\n.background {\n  position: absolute;\n  top: 0px;\n  right: 0px;\n  bottom: 0px;\n  left: 0px;\n  border-radius: var(--large-border-radius);\n}\n\n.container:hover .background {\n  background-color: var(--color-neutral-100);\n}\n\n.container:active .background {\n  background-color: var(--color-neutral-200);\n}\n\n.image {\n  width: 44px;\n  height: 44px;\n  margin-right: 24px;\n  z-index: 1;\n}\n\n.info {\n  height: 48px;\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  z-index: 1;\n}\n\n.row {\n  display: flex;\n  align-items: center;\n}\n\n.topRow {\n  composes: row;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.bottomRow {\n  composes: row;\n}\n\n.phone {\n  font-size: 16px;\n}\n\n.amount {\n  font-weight: 500;\n  color: var(--money-color);\n}\n\n.iconSpace {\n  width: 20px;\n  height: 20px;\n}\n\n.icon {\n  --size: 20px;\n  width: 44px;\n  height: 44px;\n  position: absolute;\n  top: 4px;\n  right: 0px;\n  cursor: pointer;\n  z-index: 1;\n  padding: 12px;\n  border-radius: 50%;\n}\n\n.icon:active {\n  background-color: var(--active-color);\n}\n\n.type, .time {\n  color: #707070;\n}\n\n.type {\n  margin-right: 12px;\n}\n\n.cancelled {\n  font-size: 12px;\n  font-weight: 500;\n  color: var(--accent-color);\n  background-color: #F1262611;\n  margin-left: auto;\n  padding: 2px 6px;\n  border-radius: 2px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `transaction-item-container-gu6uq`,
	"background": `transaction-item-background-Lan9C`,
	"image": `transaction-item-image-qeQyC`,
	"info": `transaction-item-info-ER8JG`,
	"row": `transaction-item-row-gQ13Y`,
	"topRow": `transaction-item-topRow-JGQW0 transaction-item-row-gQ13Y`,
	"bottomRow": `transaction-item-bottomRow-wUTpd transaction-item-row-gQ13Y`,
	"phone": `transaction-item-phone-vcMmM`,
	"amount": `transaction-item-amount-lKX30`,
	"iconSpace": `transaction-item-iconSpace-BRP5m`,
	"icon": `transaction-item-icon-vD3Y_`,
	"type": `transaction-item-type-eLLdg`,
	"time": `transaction-item-time-xDFwn`,
	"cancelled": `transaction-item-cancelled-LmPFf`
};
export default ___CSS_LOADER_EXPORT___;
